/* eslint-disable no-case-declarations */
import {
  SET_VALUE,
  REMOVE_VALUE,
  ADD_VALUE,
  SET_VALIDATED,
  SET_SCROLL_POSITION,
  ADD_RESOURCE,
  CLOSE_RESOURCE,
  SET_ACTIVE_RESOURCE,
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_FILE,
  SET_TEMPLATE,
  SET_SAVE_DISABLED,
  RESET_STATE,
  ADD_STATEMENT_TEXT,
  ADD_STATEMENT_COMMENT,
  CAN_LINK_MULTIPLE_OBJECTS,
  SET_CHECKED_URIS
} from 'constants/actionTypes';
import update from 'immutability-helper';

export const initialModalState = {
  resources: [],
  active: 0,
  showing: false,
  showAlert: true,
  showButtons: true,
  onSave: null, // on modal exit
  isPrimaryVersion: false, // images SPEC-119
  saveDisabled: false,
  canLinkMultipleObjects: false,
  checkedUris: []
};

// Reducer for modal state (resource breadcrumbs, values)
export default function(state = initialModalState, action) {
  switch (action.type) {
  case OPEN_MODAL:
    const { onSave, isPrimaryVersion } = action.settings;
    return {
      ...state,
      active: 0,
      resources: [],
      showing: true,
      onSave,
      isPrimaryVersion
    };

  case RESET_STATE:
  case CLOSE_MODAL:
    return initialModalState;
  }

  if (!state.showing) {
    return state; // Ignore actions below if modal not open!
  }

  switch (action.type) {
  // Close last element in resources array without saving
  case CLOSE_RESOURCE:
    return {
      ...state,
      resources: [...state.resources.slice(0, -1)],
      active: state.active - 1
    };
  
  case ADD_RESOURCE:
    if (state.resources.length === 0) {
      return {
        ...state,
        resources: [action.resource]
      };
    }
  
    return {
      ...state,
      resources: [...state.resources,
        action.resource
      ],
      active: state.active + 1
    };
  case ADD_STATEMENT_TEXT:
    if (state.resources.length === 0) {
      return {
        ...state,
        showAlert:false,
        showButtons: false,
        resources: [action.resource]
      };
    }
  
    return {
      ...state,
      showAlert:false,
      showButtons: false,
      resources: [...state.resources,
        action.resource
      ],
      active: state.active + 1
    };
   case ADD_STATEMENT_COMMENT:
    if (state.resources.length === 0) {
      return {
        ...state,
        showAlert:false,
        showButtons: false,
        resources: [action.resource]
      };
    }
  
    return {
      ...state,
      showAlert:false,
      showButtons: false,
      resources: [...state.resources,
        action.resource
      ],
      active: state.active + 1
    };
  /*
    User may navigate to older resources.
    (Save & close is only enabled on last resource)
  */
  case SET_ACTIVE_RESOURCE:
    return {
      ...state,
      active: action.index,
    };
  
  case SET_VALUE:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          fields: { [action.predicate]: {
            values : { [action.index]: { $set: action.value },
            }
          }}
        }
      })
    };
  
  case ADD_VALUE:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          fields: { [action.predicate]: {
            values: { $push: [action.value ? action.value : ''] }
          }}
        }
      })
    };
  
  case REMOVE_VALUE:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          fields: { [action.predicate]: {
            values: { $splice: [[action.index, 1]] }
          }}
        }
      })
    };
  
  case SET_VALIDATED:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          validated: {
            $set: true
          }
        }
      })
    };
  
  case SET_SCROLL_POSITION:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          scrollPos: {
            $set: document.querySelector('.modal').scrollTop
          }
        }
      })
    };
  
  case SET_FILE:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          file: {$set: action.file}
        }
      })
    };
  
  case SET_TEMPLATE:
    return {
      ...state,
      resources: update(state.resources, {
        [state.active]: {
          template: {$set: action.template}
        }
      })
    };

  case SET_SAVE_DISABLED:
    return {
      ...state,
      saveDisabled: action.saveDisabled
    };
  
  case CAN_LINK_MULTIPLE_OBJECTS:
    return {
      ...state,
      canLinkMultipleObjects: action.value
    };

  case SET_CHECKED_URIS:
    return {
      ...state,
      checkedUris: action.updatedUris
    };
    
    
  default: return state;
  }
}